export async function loadJSON(url) {
  try {
    // Bypass browser cache for dynamic JSON configurations
    const response = await fetch(url, { cache: 'no-store' });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('Could not load data from', url, error);
    return null;
  }
}
